import { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import GridTableComponent from "./tableData/tableData";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { isNil } from "lodash";
import styles from "./timeSlots.module.scss";
import Summary from "./summaryComponent/summaryComponent";
import { Box, Button,styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CommonButton } from "../../common/StyledComponents/StyledFields";
import ToastComponent from "../../common/toastComponent";
import { apiRequest, catchErrorMessageHandler, getUserID } from "../../../infrastructure/backendService";
import { backendResponseProps, dateWithEventAndSlotListProps, slotsListProps } from "../../../infrastructure/GlobalContextProvider";
import ToastError from "../../common/toast/toastError";
import apiPath from "../../../config/apiPaths.json";
import ErrorPopup from "../../common/ErrorPopup";
import constants from "../../../config/constants.json";

interface ModifiedTask extends slotsListProps {
  Actions: JSX.Element;
}

export const AccordianButton = styled(Button)`
  border-radius: 4px;
  display: inline-flex;
  padding: 8px 16px;
  height: 38px;
  box-shadow: none;
  width: auto;
  color: #fff;
  text-transform: capitalize;
  align-items: flex-start;
  text-align: center;
  gap: 10px;
  
  &:disabled{
    cursor: not-allowed;
    color: #f051026e;
    /* color: white; */
  }
`;

const TimeSlots = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [expandedAccordion, setExpandedAccordion] = useState<string | null>(
    null
  );
  const [backendResponse, setBackendResponse] = useState<
    backendResponseProps[] | null
  >([]);
  const [dateId, setDateId] = useState<number | null>(null);
  const [errorMessage, setErrMessage] = useState<string | null>(null);
  const [modifiedResponse, setModifiedResponse] = useState<
    backendResponseProps[]
  >([]);
  const [showSummaryPage, setShowSummaryPage] = useState<boolean>(false);
  const [registerID, setRegisterID] = useState<number | null>(null);
  const [disableFinalButton, setdisableFinalButton] = useState<boolean>(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.getNewYearEventsSlotsApi,
      params: {
        id: getUserID(),
      },
    })
      .then((res) => {
        console.log(res.data);
        setBackendResponse(res.data.dateEventSlotResponse);
        setRegisterID(res.data.registeredId);
        setErrMessage(null);
      })
      .catch((err) => {
        console.log(err);
        // toast.custom(<ToastError message={catchErrorMessageHandler(err)} />, {
        //   duration: 10000,
        // });
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, []);

  const accordionData = (
    title: string,
    tableData: slotsListProps[],
    id: number
  ) => {
    return (
      <Box
        sx={{
          borderRadius: "8px",
          padding: "8px 40px 35px 40px",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          background: "#FFF9E4",
        }}
      >
        <h3>{title}</h3>
        <GridTableComponent
          tableData={convertApiResponseToModifiedFormat(tableData, id)}
        />
      </Box>
    );
  };

  const accordionComponent = (
    title: string,
    insideDataList: dateWithEventAndSlotListProps[]
  ) => {
    const isAccordionExpanded = expandedAccordion === title;

    const handleAccordionChange = () => {
      setExpandedAccordion((prevExpanded) =>
        prevExpanded === title ? null : title
      );
    };

    return (
      <Accordion
        expanded={isAccordionExpanded}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          // expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}
          aria-controls={`panel-${title}-content`}
          id={`panel-${title}-header`}
        >
          <img
            src="/images/accordianImage.svg"
            style={{
              width: "16px",
              height: "16px",
              marginRight: "10px",
              marginTop: "4px",
            }}
          />
          <Typography className={styles.AccordianTitle}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {isAccordionExpanded && (
            <>
              {insideDataList.map((item) => (
                <>{accordionData(item.eventName, item.slotsList, item.id)}</>
              ))}
            </>
          )}
        </AccordionDetails>
      </Accordion>
    );
  };


  const handleRegister = (
    task: slotsListProps,
    eventId: number,
    dateId: number | null
  ) => {
    if (!isNil(dateId)) {
      const isAlreadyRegistered = modifiedResponse.some(
        (item) =>
          item.id === dateId &&
          item.dateWithEventAndSlotList.some(
            (event) =>
              event.id !== eventId && // Check for a different event
              event.slotsList.some(
                (slot) => slot.id === task.id && slot.isRegistered
              )
          )
      );

      if (isAlreadyRegistered) {
        // Show alert message
        console.log(isAlreadyRegistered, "al");
        toast.error("You are already registered in this time slot on the same day.")
        // alert("You are already registered in this time slot on the same day.");
        return;
      }

      const updatedTasks: backendResponseProps[] = (backendResponse ?? []).map(
        (item) => {
          if (item.id === dateId) {
            item.dateWithEventAndSlotList.forEach((event) => {
              if (event.id === eventId) {
                event.slotsList.forEach((slot) => {
                  if (slot.id === task.id) {
                    slot.isRegistered = true;
                    slot.isChanged = true;
                  }
                });
              }
            });
          }
          return item;
        }
      );

      setModifiedResponse(updatedTasks);
    }
  };

  const handleWithdraw = (
    task: slotsListProps,
    eventId: number,
    dateId: number | null
  ) => {
    if (!isNil(dateId)) {
      const updatedTasks: backendResponseProps[] = (backendResponse ?? []).map(
        (item) => {
          if (item.id === dateId) {
            item.dateWithEventAndSlotList.forEach((event) => {
              if (event.id === eventId) {
                event.slotsList.forEach((slot) => {
                  if (slot.id === task.id) {
                    slot.isRegistered = false;
                    slot.isChanged = true;
                  }
                });
              }
            });
          }
          return item;
        }
      );

      setModifiedResponse(updatedTasks);
    }
  };

  const convertApiResponseToModifiedFormat = (
    apiResponse: slotsListProps[],
    id: number
  ): ModifiedTask[] => {
    return apiResponse.map((task) => ({
      ...task,
      Actions: (
        <div>
          <AccordianButton sx={{background:"none", color:"#F05802",fontWeight:"700"}}
            disabled={task.isRegistered}
            onClick={() => handleRegister(task, id, dateId)}
          >
            Register
          </AccordianButton>
          {" / "}
          <AccordianButton sx={{background:"none", color:"#F05802",fontWeight:"700"}}
            disabled={!task.isRegistered}
            onClick={() => handleWithdraw(task, id, dateId)}
          >
            Withdrawn
          </AccordianButton>
        </div>
      ),
    }));
  };

  const onClickSlot = (id: number) => {
    setDateId(id);
  };

  const render = () : React.ReactElement => {
    return (
      <>
        {!isNil(backendResponse) && backendResponse?.length > 0 ? (
          <>
            {backendResponse?.map(
              (item: backendResponseProps, index: number) => (
                <div
                  key={index}
                  style={{ marginBottom: "10px" }}
                  onClick={() => onClickSlot(item.id)}
                >
                  {accordionComponent(
                    item?.formattedDate,
                    item?.dateWithEventAndSlotList
                  )}
                </div>
              )
            )}
          </>
        ) : (
          <Typography>
            {!isNil(errorMessage) ? `Loading...` : `${errorMessage}`}
          </Typography>
        )}
      </>
    );
  };

  const getRegisteredItems = (): backendResponseProps[] => {
    return (modifiedResponse ?? []).reduce((accumulator, item) => {
      const newItem: backendResponseProps = {
        ...item,
        dateWithEventAndSlotList: item.dateWithEventAndSlotList.map(
          (event) => ({
            ...event,
            slotsList: event.slotsList.filter((slot) => slot.isRegistered),
          })
        ),
      };

      // Only append newItem to the list if any slots are registered
      if (
        newItem.dateWithEventAndSlotList.some(
          (event) => event.slotsList.length > 0
        )
      ) {
        accumulator.push(newItem);
      }

      return accumulator;
    }, [] as backendResponseProps[]);
  };

  const onSubmitActions = () => {
    setShowSummaryPage(true);
  };

  const finalSubmitApiCall = () => {
    const reqBody = {
      registeredId: registerID,
      dateEventSlotResponse: modifiedResponse,
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.submitNewYearVolunteerSlots,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        // toast.success("Volunteer Registered successful.Please check your mail");
        setdisableFinalButton(true);
        navigate('/success/true');
      })
      .catch((err) => {
        console.log(err);
        setdisableFinalButton(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const hasChangesInSlots = () => {
    return modifiedResponse.some((item) =>
      item.dateWithEventAndSlotList.some((event) =>
        event.slotsList.some((slot) => slot.isChanged || slot.isRegistered)
      )
    );
  };


  const getAllUpdatedItems = (): backendResponseProps[] => {
    return (modifiedResponse ?? []).map((item) => {
      const newItem: backendResponseProps = {
        ...item,
        dateWithEventAndSlotList: item.dateWithEventAndSlotList.map(
          (event) => ({
            ...event,
            slotsList: event.slotsList.filter(
              (slot) => slot.isRegistered || slot.isChanged
            ),
          })
        ),
      };
  
      // Only append newItem to the list if any slots are registered or withdrawn
      if (
        newItem.dateWithEventAndSlotList.some(
          (event) => event.slotsList.length > 0
        )
      ) {
        return newItem;
      }
  
      return null;
    }).filter(Boolean) as backendResponseProps[];
  };
  

  const onClickCancel = () : void => {
    navigate('/');
  }

  const timeSlotsComponent = () => {
    return (
      <>
        <h3>
          New Year 2024 Volunteer Registration – Day, Time-Slot and Category
          Choice
        </h3>
        {render()}
        <CommonButton 
          onClick={onClickCancel}
        >
          Cancel
        </CommonButton>
        <CommonButton sx={{marginLeft:"10px"}}
          onClick={onSubmitActions}
          disabled={getRegisteredItems().length === 0}
        >
          Continue
        </CommonButton>
      </>
    );
  };


  return (
    <div>
      <ToastComponent />
      {!showSummaryPage ? (
        timeSlotsComponent()
      ) : (
        <Summary
          setShowSummaryPage={setShowSummaryPage}
          onClickSubmit={finalSubmitApiCall}
          registeredDataList={getRegisteredItems()}
          submitDisable={disableFinalButton}
        />
      )}
    </div>
  );
};

export default TimeSlots;
